<template>
    <EditContrat />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
    import EditContrat from "@/components/GesCom/Contrat/EditContrat.vue";
    export default defineComponent({
      name: "EditContratPage",
      components: {
        EditContrat,
      },
    });
  </script>